/**
 * Generated from SettingsPopupLayout.fla
 */
export function SettingsPopupLayout(this: ISettingsPopupLayout) {
	const audioSliderBg = this.audioSliderBg;
	if (!audioSliderBg[0] && audioSliderBg.elementFactory) {
		audioSliderBg[0] = audioSliderBg.elementFactory(0,undefined);
	}
	if (audioSliderBg[0]) {
		SettingsPopupLayout_audioSliderBg0.call(audioSliderBg[0] as ISettingsPopupLayout_audioSliderBg0);
		audioSliderBg[0].x = 322.85;
		audioSliderBg[0].y = 337.5;
		audioSliderBg[0].width = 299.00;
		audioSliderBg[0].height = 59.50;
		if (audioSliderBg[0].onLayout) audioSliderBg[0].onLayout();
	}
	if (!audioSliderBg[1] && audioSliderBg.elementFactory) {
		audioSliderBg[1] = audioSliderBg.elementFactory(1,undefined);
	}
	if (audioSliderBg[1]) {
		SettingsPopupLayout_audioSliderBg0.call(audioSliderBg[1] as ISettingsPopupLayout_audioSliderBg0);
		audioSliderBg[1].x = 322.85;
		audioSliderBg[1].y = 441.5;
		audioSliderBg[1].width = 299.00;
		audioSliderBg[1].height = 59.50;
		if (audioSliderBg[1].onLayout) audioSliderBg[1].onLayout();
	}
	if (!audioSliderBg[2] && audioSliderBg.elementFactory) {
		audioSliderBg[2] = audioSliderBg.elementFactory(2,undefined);
	}
	if (audioSliderBg[2]) {
		SettingsPopupLayout_audioSliderBg0.call(audioSliderBg[2] as ISettingsPopupLayout_audioSliderBg0);
		audioSliderBg[2].x = 322.85;
		audioSliderBg[2].y = 546.5;
		audioSliderBg[2].width = 299.00;
		audioSliderBg[2].height = 59.50;
		if (audioSliderBg[2].onLayout) audioSliderBg[2].onLayout();
	}
	const switchControlsSprite = this.switchControlsSprite;
	if (!switchControlsSprite[0] && switchControlsSprite.elementFactory) {
		switchControlsSprite[0] = switchControlsSprite.elementFactory(0,undefined);
	}
	if (switchControlsSprite[0]) {
		SettingsPopupLayout_switchControlsSpriteScan.call(switchControlsSprite[0] as ISettingsPopupLayout_switchControlsSpriteScan);
		switchControlsSprite[0].x = 569;
		switchControlsSprite[0].y = 372;
		switchControlsSprite[0].width = 174.00;
		switchControlsSprite[0].height = 77.00;
		if (switchControlsSprite[0].onLayout) switchControlsSprite[0].onLayout();
	}
	if (!switchControlsSprite[1] && switchControlsSprite.elementFactory) {
		switchControlsSprite[1] = switchControlsSprite.elementFactory(1,undefined);
	}
	if (switchControlsSprite[1]) {
		SettingsPopupLayout_switchControlsSpriteSelect.call(switchControlsSprite[1] as ISettingsPopupLayout_switchControlsSpriteSelect);
		switchControlsSprite[1].x = 568.45;
		switchControlsSprite[1].y = 488.75;
		switchControlsSprite[1].width = 174.50;
		switchControlsSprite[1].height = 77.00;
		if (switchControlsSprite[1].onLayout) switchControlsSprite[1].onLayout();
	}
	const doneButton = this.doneButton;
	SettingsPopupLayout_doneButton.call(this.doneButton);
	doneButton.x = 512;
	doneButton.y = 671.1;
	doneButton.width = 188.00;
	doneButton.height = 114.50;
	if (doneButton.onLayout) doneButton.onLayout();
	const soundAndCaptionSettingsButton = this.soundAndCaptionSettingsButton;
	SettingsPopupLayout_soundAndCaptionSettingsButton.call(this.soundAndCaptionSettingsButton);
	soundAndCaptionSettingsButton.x = 132.15;
	soundAndCaptionSettingsButton.y = 135.95;
	soundAndCaptionSettingsButton.width = 248.00;
	soundAndCaptionSettingsButton.height = 80.00;
	if (soundAndCaptionSettingsButton.onLayout) soundAndCaptionSettingsButton.onLayout();
	const switchControlsButton = this.switchControlsButton;
	SettingsPopupLayout_switchControlsButton.call(this.switchControlsButton);
	switchControlsButton.x = 894.1;
	switchControlsButton.y = 135.95;
	switchControlsButton.width = 248.00;
	switchControlsButton.height = 80.00;
	if (switchControlsButton.onLayout) switchControlsButton.onLayout();
	const gameplaySettingsButton = this.gameplaySettingsButton;
	SettingsPopupLayout_gameplaySettingsButton.call(this.gameplaySettingsButton);
	gameplaySettingsButton.x = 386;
	gameplaySettingsButton.y = 135.95;
	gameplaySettingsButton.width = 248.00;
	gameplaySettingsButton.height = 80.00;
	if (gameplaySettingsButton.onLayout) gameplaySettingsButton.onLayout();
	const displaySettingsButton = this.displaySettingsButton;
	SettingsPopupLayout_displaySettingsButton.call(this.displaySettingsButton);
	displaySettingsButton.x = 640.5;
	displaySettingsButton.y = 136.45;
	displaySettingsButton.width = 248.00;
	displaySettingsButton.height = 80.00;
	if (displaySettingsButton.onLayout) displaySettingsButton.onLayout();
	const helpButton = this.helpButton;
	SettingsPopupLayout_helpButton.call(this.helpButton);
	helpButton.x = 848.4;
	helpButton.y = 695.5;
	helpButton.width = 85.50;
	helpButton.height = 91.00;
	if (helpButton.onLayout) helpButton.onLayout();
	const resetButton = this.resetButton;
	SettingsPopupLayout_resetButton.call(this.resetButton);
	resetButton.x = 970.75;
	resetButton.y = 696.25;
	resetButton.width = 85.50;
	resetButton.height = 91.00;
	if (resetButton.onLayout) resetButton.onLayout();
	const audioPanel = this.audioPanel;
	SettingsPopupLayout_audioPanel.call(this.audioPanel);
	audioPanel.x = 323.5;
	audioPanel.y = 401.45;
	audioPanel.width = 337.00;
	audioPanel.height = 400.00;
	if (audioPanel.onLayout) audioPanel.onLayout();
	const audioDescriptionsPanel = this.audioDescriptionsPanel;
	SettingsPopupLayout_audioDescriptionsPanel.call(this.audioDescriptionsPanel);
	audioDescriptionsPanel.x = 735.1;
	audioDescriptionsPanel.y = 298.2;
	audioDescriptionsPanel.width = 430.00;
	audioDescriptionsPanel.height = 188.50;
	if (audioDescriptionsPanel.onLayout) audioDescriptionsPanel.onLayout();
	const closedCaptioningPanel = this.closedCaptioningPanel;
	SettingsPopupLayout_closedCaptioningPanel.call(this.closedCaptioningPanel);
	closedCaptioningPanel.x = 734.4;
	closedCaptioningPanel.y = 504.3;
	closedCaptioningPanel.width = 430.00;
	closedCaptioningPanel.height = 188.50;
	if (closedCaptioningPanel.onLayout) closedCaptioningPanel.onLayout();
	const audioDescriptionsToggleBG = this.audioDescriptionsToggleBG;
	SettingsPopupLayout_audioDescriptionsToggleBG.call(this.audioDescriptionsToggleBG);
	audioDescriptionsToggleBG.x = 734.6;
	audioDescriptionsToggleBG.y = 333.5;
	audioDescriptionsToggleBG.width = 217.50;
	audioDescriptionsToggleBG.height = 59.50;
	if (audioDescriptionsToggleBG.onLayout) audioDescriptionsToggleBG.onLayout();
	const closedCaptionsToggleBG = this.closedCaptionsToggleBG;
	SettingsPopupLayout_closedCaptionsToggleBG.call(this.closedCaptionsToggleBG);
	closedCaptionsToggleBG.x = 734.4;
	closedCaptionsToggleBG.y = 538.3;
	closedCaptionsToggleBG.width = 217.50;
	closedCaptionsToggleBG.height = 59.50;
	if (closedCaptionsToggleBG.onLayout) closedCaptionsToggleBG.onLayout();
	const musicSliderIcon = this.musicSliderIcon;
	SettingsPopupLayout_musicSliderIcon.call(this.musicSliderIcon);
	musicSliderIcon.x = 206.8;
	musicSliderIcon.y = 336;
	musicSliderIcon.width = 30.00;
	musicSliderIcon.height = 35.00;
	if (musicSliderIcon.onLayout) musicSliderIcon.onLayout();
	const soundEffectsSliderIcon = this.soundEffectsSliderIcon;
	SettingsPopupLayout_soundEffectsSliderIcon.call(this.soundEffectsSliderIcon);
	soundEffectsSliderIcon.x = 210.05;
	soundEffectsSliderIcon.y = 440.55;
	soundEffectsSliderIcon.width = 36.50;
	soundEffectsSliderIcon.height = 28.50;
	if (soundEffectsSliderIcon.onLayout) soundEffectsSliderIcon.onLayout();
	const voiceoverSliderIcon = this.voiceoverSliderIcon;
	SettingsPopupLayout_voiceoverSliderIcon.call(this.voiceoverSliderIcon);
	voiceoverSliderIcon.x = 210.5;
	voiceoverSliderIcon.y = 545;
	voiceoverSliderIcon.width = 34.50;
	voiceoverSliderIcon.height = 33.50;
	if (voiceoverSliderIcon.onLayout) voiceoverSliderIcon.onLayout();
	const flightSpeedPanel = this.flightSpeedPanel;
	SettingsPopupLayout_flightSpeedPanel.call(this.flightSpeedPanel);
	flightSpeedPanel.x = 512;
	flightSpeedPanel.y = 497;
	flightSpeedPanel.width = 888.41;
	flightSpeedPanel.height = 198.50;
	if (flightSpeedPanel.onLayout) flightSpeedPanel.onLayout();
	const difficultyPanel = this.difficultyPanel;
	SettingsPopupLayout_difficultyPanel.call(this.difficultyPanel);
	difficultyPanel.x = 512;
	difficultyPanel.y = 288.45;
	difficultyPanel.width = 425.00;
	difficultyPanel.height = 198.50;
	if (difficultyPanel.onLayout) difficultyPanel.onLayout();
	const difficultySliderBg = this.difficultySliderBg;
	SettingsPopupLayout_difficultySliderBg.call(this.difficultySliderBg);
	difficultySliderBg.x = 512;
	difficultySliderBg.y = 320.7;
	difficultySliderBg.width = 318.50;
	difficultySliderBg.height = 92.50;
	if (difficultySliderBg.onLayout) difficultySliderBg.onLayout();
	const difficultySliderLabel = this.difficultySliderLabel;
	SettingsPopupLayout_difficultySliderLabel.call(this.difficultySliderLabel);
	difficultySliderLabel.x = 497;
	difficultySliderLabel.y = 303.9;
	difficultySliderLabel.width = 254.00;
	difficultySliderLabel.height = 14.05;
	if (difficultySliderLabel.onLayout) difficultySliderLabel.onLayout();
	const flightSpeedSliderBg = this.flightSpeedSliderBg;
	SettingsPopupLayout_flightSpeedSliderBg.call(this.flightSpeedSliderBg);
	flightSpeedSliderBg.x = 512.5;
	flightSpeedSliderBg.y = 529;
	flightSpeedSliderBg.width = 682.00;
	flightSpeedSliderBg.height = 92.50;
	if (flightSpeedSliderBg.onLayout) flightSpeedSliderBg.onLayout();
	const flightSpeedSliderLabel = this.flightSpeedSliderLabel;
	SettingsPopupLayout_flightSpeedSliderLabel.call(this.flightSpeedSliderLabel);
	flightSpeedSliderLabel.x = 512.25;
	flightSpeedSliderLabel.y = 507.45;
	flightSpeedSliderLabel.width = 576.50;
	flightSpeedSliderLabel.height = 14.00;
	if (flightSpeedSliderLabel.onLayout) flightSpeedSliderLabel.onLayout();
	const textSizePanel = this.textSizePanel;
	SettingsPopupLayout_displayPanelBg.call(this.textSizePanel);
	textSizePanel.x = 174.4;
	textSizePanel.y = 292;
	textSizePanel.width = 330.00;
	textSizePanel.height = 198.50;
	if (textSizePanel.onLayout) textSizePanel.onLayout();
	const colorBlindPanel = this.colorBlindPanel;
	SettingsPopupLayout_displayPanelBg.call(this.colorBlindPanel);
	colorBlindPanel.x = 512.9;
	colorBlindPanel.y = 292;
	colorBlindPanel.width = 330.00;
	colorBlindPanel.height = 198.50;
	if (colorBlindPanel.onLayout) colorBlindPanel.onLayout();
	const reducedAnimationPanel = this.reducedAnimationPanel;
	SettingsPopupLayout_displayPanelBg.call(this.reducedAnimationPanel);
	reducedAnimationPanel.x = 850.95;
	reducedAnimationPanel.y = 292;
	reducedAnimationPanel.width = 330.00;
	reducedAnimationPanel.height = 198.50;
	if (reducedAnimationPanel.onLayout) reducedAnimationPanel.onLayout();
	const buttonSizePanel = this.buttonSizePanel;
	SettingsPopupLayout_displayPanelBg.call(this.buttonSizePanel);
	buttonSizePanel.x = 174.4;
	buttonSizePanel.y = 498.05;
	buttonSizePanel.width = 330.00;
	buttonSizePanel.height = 198.50;
	if (buttonSizePanel.onLayout) buttonSizePanel.onLayout();
	const contrastPanel = this.contrastPanel;
	SettingsPopupLayout_displayPanelBg.call(this.contrastPanel);
	contrastPanel.x = 512.9;
	contrastPanel.y = 498.05;
	contrastPanel.width = 330.00;
	contrastPanel.height = 198.50;
	if (contrastPanel.onLayout) contrastPanel.onLayout();
	const backgroundImagesPanel = this.backgroundImagesPanel;
	SettingsPopupLayout_displayPanelBg.call(this.backgroundImagesPanel);
	backgroundImagesPanel.x = 850.9;
	backgroundImagesPanel.y = 498.05;
	backgroundImagesPanel.width = 330.00;
	backgroundImagesPanel.height = 198.50;
	if (backgroundImagesPanel.onLayout) backgroundImagesPanel.onLayout();
	const textSizeSliderBg = this.textSizeSliderBg;
	SettingsPopupLayout_textSizeSliderBg.call(this.textSizeSliderBg);
	textSizeSliderBg.x = 174.45;
	textSizeSliderBg.y = 324.75;
	textSizeSliderBg.width = 285.50;
	textSizeSliderBg.height = 92.50;
	if (textSizeSliderBg.onLayout) textSizeSliderBg.onLayout();
	const textSizeSliderLabel = this.textSizeSliderLabel;
	SettingsPopupLayout_textSizeSliderLabel.call(this.textSizeSliderLabel);
	textSizeSliderLabel.x = 177.45;
	textSizeSliderLabel.y = 309;
	textSizeSliderLabel.width = 178.50;
	textSizeSliderLabel.height = 21.50;
	if (textSizeSliderLabel.onLayout) textSizeSliderLabel.onLayout();
	const buttonSizeSliderBg = this.buttonSizeSliderBg;
	SettingsPopupLayout_textSizeSliderBg.call(this.buttonSizeSliderBg);
	buttonSizeSliderBg.x = 174.45;
	buttonSizeSliderBg.y = 530.75;
	buttonSizeSliderBg.width = 285.50;
	buttonSizeSliderBg.height = 92.50;
	if (buttonSizeSliderBg.onLayout) buttonSizeSliderBg.onLayout();
	const contrastSliderBg = this.contrastSliderBg;
	SettingsPopupLayout_textSizeSliderBg.call(this.contrastSliderBg);
	contrastSliderBg.x = 513.45;
	contrastSliderBg.y = 530.75;
	contrastSliderBg.width = 285.50;
	contrastSliderBg.height = 92.50;
	if (contrastSliderBg.onLayout) contrastSliderBg.onLayout();
	const colorBlindSliderBg = this.colorBlindSliderBg;
	SettingsPopupLayout_textSizeSliderBg.call(this.colorBlindSliderBg);
	colorBlindSliderBg.x = 513.45;
	colorBlindSliderBg.y = 324.75;
	colorBlindSliderBg.width = 285.50;
	colorBlindSliderBg.height = 92.50;
	if (colorBlindSliderBg.onLayout) colorBlindSliderBg.onLayout();
	const reducedAnimationSliderBg = this.reducedAnimationSliderBg;
	SettingsPopupLayout_textSizeSliderBg.call(this.reducedAnimationSliderBg);
	reducedAnimationSliderBg.x = 850.95;
	reducedAnimationSliderBg.y = 324.75;
	reducedAnimationSliderBg.width = 285.50;
	reducedAnimationSliderBg.height = 92.50;
	if (reducedAnimationSliderBg.onLayout) reducedAnimationSliderBg.onLayout();
	const reducedAnimationSliderLabel = this.reducedAnimationSliderLabel;
	SettingsPopupLayout_reducedAnimationSliderLabel.call(this.reducedAnimationSliderLabel);
	reducedAnimationSliderLabel.x = 850.05;
	reducedAnimationSliderLabel.y = 307.75;
	reducedAnimationSliderLabel.width = 181.50;
	reducedAnimationSliderLabel.height = 15.00;
	if (reducedAnimationSliderLabel.onLayout) reducedAnimationSliderLabel.onLayout();
	const backgroundImagesSliderLabel = this.backgroundImagesSliderLabel;
	SettingsPopupLayout_backgroundImagesSliderLabel.call(this.backgroundImagesSliderLabel);
	backgroundImagesSliderLabel.x = 847.55;
	backgroundImagesSliderLabel.y = 503;
	backgroundImagesSliderLabel.width = 212.00;
	backgroundImagesSliderLabel.height = 44.00;
	if (backgroundImagesSliderLabel.onLayout) backgroundImagesSliderLabel.onLayout();
	const colorblindSliderLabel = this.colorblindSliderLabel;
	SettingsPopupLayout_colorblindSliderLabel.call(this.colorblindSliderLabel);
	colorblindSliderLabel.x = 512;
	colorblindSliderLabel.y = 309.25;
	colorblindSliderLabel.width = 203.50;
	colorblindSliderLabel.height = 22.00;
	if (colorblindSliderLabel.onLayout) colorblindSliderLabel.onLayout();
	const contrastSliderLabel = this.contrastSliderLabel;
	SettingsPopupLayout_contrastSliderLabel.call(this.contrastSliderLabel);
	contrastSliderLabel.x = 512.75;
	contrastSliderLabel.y = 509.95;
	contrastSliderLabel.width = 183.00;
	contrastSliderLabel.height = 21.00;
	if (contrastSliderLabel.onLayout) contrastSliderLabel.onLayout();
	const buttonSizeSliderLabel = this.buttonSizeSliderLabel;
	SettingsPopupLayout_buttonSizeSliderLabel.call(this.buttonSizeSliderLabel);
	buttonSizeSliderLabel.x = 172.05;
	buttonSizeSliderLabel.y = 513.75;
	buttonSizeSliderLabel.width = 195.50;
	buttonSizeSliderLabel.height = 15.00;
	if (buttonSizeSliderLabel.onLayout) buttonSizeSliderLabel.onLayout();
	const controlsPanel = this.controlsPanel;
	SettingsPopupLayout_controlsPanel.call(this.controlsPanel);
	controlsPanel.x = 507;
	controlsPanel.y = 397.5;
	controlsPanel.width = 567.00;
	controlsPanel.height = 405.50;
	if (controlsPanel.onLayout) controlsPanel.onLayout();
	const controlsPanelKeyboardTabBg = this.controlsPanelKeyboardTabBg;
	SettingsPopupLayout_controlsPanelKeyboardTabBg.call(this.controlsPanelKeyboardTabBg);
	controlsPanelKeyboardTabBg.x = 504.5;
	controlsPanelKeyboardTabBg.y = 430;
	controlsPanelKeyboardTabBg.width = 490.50;
	controlsPanelKeyboardTabBg.height = 290.00;
	if (controlsPanelKeyboardTabBg.onLayout) controlsPanelKeyboardTabBg.onLayout();
	const controlsPanelSwitchTabBg = this.controlsPanelSwitchTabBg;
	SettingsPopupLayout_controlsPanelSwitchTabBg.call(this.controlsPanelSwitchTabBg);
	controlsPanelSwitchTabBg.x = 504.5;
	controlsPanelSwitchTabBg.y = 430;
	controlsPanelSwitchTabBg.width = 490.50;
	controlsPanelSwitchTabBg.height = 290.00;
	if (controlsPanelSwitchTabBg.onLayout) controlsPanelSwitchTabBg.onLayout();
	const controlsPanelGazeTabBg = this.controlsPanelGazeTabBg;
	SettingsPopupLayout_controlsPanelGazeTabBg.call(this.controlsPanelGazeTabBg);
	controlsPanelGazeTabBg.x = 504.5;
	controlsPanelGazeTabBg.y = 430;
	controlsPanelGazeTabBg.width = 490.50;
	controlsPanelGazeTabBg.height = 290.00;
	if (controlsPanelGazeTabBg.onLayout) controlsPanelGazeTabBg.onLayout();
	const controlsPanelKeyboardTabButton = this.controlsPanelKeyboardTabButton;
	SettingsPopupLayout_controlsPanelKeyboardTabButton.call(this.controlsPanelKeyboardTabButton);
	controlsPanelKeyboardTabButton.x = 331.7;
	controlsPanelKeyboardTabButton.y = 330;
	controlsPanelKeyboardTabButton.width = 80.00;
	controlsPanelKeyboardTabButton.height = 60.00;
	if (controlsPanelKeyboardTabButton.onLayout) controlsPanelKeyboardTabButton.onLayout();
	const controlsPanelSwitchTabButton = this.controlsPanelSwitchTabButton;
	SettingsPopupLayout_controlsPanelSwitchTabButton.call(this.controlsPanelSwitchTabButton);
	controlsPanelSwitchTabButton.x = 331.25;
	controlsPanelSwitchTabButton.y = 431.25;
	controlsPanelSwitchTabButton.width = 70.50;
	controlsPanelSwitchTabButton.height = 46.50;
	if (controlsPanelSwitchTabButton.onLayout) controlsPanelSwitchTabButton.onLayout();
	const controlsPanelGazeTabButton = this.controlsPanelGazeTabButton;
	SettingsPopupLayout_controlsPanelGazeTabButton.call(this.controlsPanelGazeTabButton);
	controlsPanelGazeTabButton.x = 329.5;
	controlsPanelGazeTabButton.y = 525.5;
	controlsPanelGazeTabButton.width = 78.00;
	controlsPanelGazeTabButton.height = 68.50;
	if (controlsPanelGazeTabButton.onLayout) controlsPanelGazeTabButton.onLayout();
	const keyboardControlsSprite = this.keyboardControlsSprite;
	SettingsPopupLayout_keyboardControlsSprite.call(this.keyboardControlsSprite);
	keyboardControlsSprite.x = 570.5;
	keyboardControlsSprite.y = 427;
	keyboardControlsSprite.width = 110.50;
	keyboardControlsSprite.height = 216.00;
	if (keyboardControlsSprite.onLayout) keyboardControlsSprite.onLayout();
	const gazeControlsSprite = this.gazeControlsSprite;
	SettingsPopupLayout_gazeControlsSprite.call(this.gazeControlsSprite);
	gazeControlsSprite.x = 567;
	gazeControlsSprite.y = 431.5;
	gazeControlsSprite.width = 229.00;
	gazeControlsSprite.height = 141.50;
	if (gazeControlsSprite.onLayout) gazeControlsSprite.onLayout();
	return this;
}
function SettingsPopupLayout_doneButton(this: ISettingsPopupLayout_doneButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-done.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_soundAndCaptionSettingsButton(this: ISettingsPopupLayout_soundAndCaptionSettingsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-tab-sound.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_switchControlsButton(this: ISettingsPopupLayout_switchControlsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-tab-controls.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_gameplaySettingsButton(this: ISettingsPopupLayout_gameplaySettingsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-tab-gameplay.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_displaySettingsButton(this: ISettingsPopupLayout_displaySettingsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-tab-display.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_helpButton(this: ISettingsPopupLayout_helpButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-help.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_resetButton(this: ISettingsPopupLayout_resetButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-btn-reset.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_audioPanel(this: ISettingsPopupLayout_audioPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-sound-audio.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_audioDescriptionsPanel(this: ISettingsPopupLayout_audioDescriptionsPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-sound-cc.png", 0.500, 0.501);
	return this;
}
function SettingsPopupLayout_closedCaptioningPanel(this: ISettingsPopupLayout_closedCaptioningPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-sound-cc.png", 0.500, 0.501);
	return this;
}
function SettingsPopupLayout_audioDescriptionsToggleBG(this: ISettingsPopupLayout_audioDescriptionsToggleBG) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-toggle-container.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_closedCaptionsToggleBG(this: ISettingsPopupLayout_closedCaptionsToggleBG) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-toggle-container.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_audioSliderBg0(this: ISettingsPopupLayout_audioSliderBg0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-audio-container.png", 0.500, 0.504);
	return this;
}
function SettingsPopupLayout_musicSliderIcon(this: ISettingsPopupLayout_musicSliderIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-icon-music.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_soundEffectsSliderIcon(this: ISettingsPopupLayout_soundEffectsSliderIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-icon-sfx.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_voiceoverSliderIcon(this: ISettingsPopupLayout_voiceoverSliderIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-icon-vo.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_flightSpeedPanel(this: ISettingsPopupLayout_flightSpeedPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-speed.png", 0.500, 0.501);
	return this;
}
function SettingsPopupLayout_difficultyPanel(this: ISettingsPopupLayout_difficultyPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-challenge.png", 0.500, 0.501);
	return this;
}
function SettingsPopupLayout_difficultySliderBg(this: ISettingsPopupLayout_difficultySliderBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-pillshape-2.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_difficultySliderLabel(this: ISettingsPopupLayout_difficultySliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-challenge.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_flightSpeedSliderBg(this: ISettingsPopupLayout_flightSpeedSliderBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-gameplay-pillshape-xlarge.png", 0.501, 0.503);
	return this;
}
function SettingsPopupLayout_flightSpeedSliderLabel(this: ISettingsPopupLayout_flightSpeedSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-gameplay-speed.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_displayPanelBg(this: ISettingsPopupLayout_displayPanelBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-container-display.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_textSizeSliderBg(this: ISettingsPopupLayout_textSizeSliderBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-pillshape.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_textSizeSliderLabel(this: ISettingsPopupLayout_textSizeSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-textsize.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_reducedAnimationSliderLabel(this: ISettingsPopupLayout_reducedAnimationSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-animations.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_backgroundImagesSliderLabel(this: ISettingsPopupLayout_backgroundImagesSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-backgrounds.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_colorblindSliderLabel(this: ISettingsPopupLayout_colorblindSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-color.png", 0.461, 0.273);
	return this;
}
function SettingsPopupLayout_contrastSliderLabel(this: ISettingsPopupLayout_contrastSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-contrast.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_buttonSizeSliderLabel(this: ISettingsPopupLayout_buttonSizeSliderLabel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-display-btnsize.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanel(this: ISettingsPopupLayout_controlsPanel) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-container-large.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelKeyboardTabBg(this: ISettingsPopupLayout_controlsPanelKeyboardTabBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-container-keyboard.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelSwitchTabBg(this: ISettingsPopupLayout_controlsPanelSwitchTabBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-container-switch.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelGazeTabBg(this: ISettingsPopupLayout_controlsPanelGazeTabBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-headeye-container.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelKeyboardTabButton(this: ISettingsPopupLayout_controlsPanelKeyboardTabButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-keyboard-icon.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelSwitchTabButton(this: ISettingsPopupLayout_controlsPanelSwitchTabButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-switch-icon.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_controlsPanelGazeTabButton(this: ISettingsPopupLayout_controlsPanelGazeTabButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-headeye-icon.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_keyboardControlsSprite(this: ISettingsPopupLayout_keyboardControlsSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-keyboard.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_switchControlsSpriteScan(this: ISettingsPopupLayout_switchControlsSpriteScan) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-switch1.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_switchControlsSpriteSelect(this: ISettingsPopupLayout_switchControlsSpriteSelect) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-switch2.png", 0.500, 0.500);
	return this;
}
function SettingsPopupLayout_gazeControlsSprite(this: ISettingsPopupLayout_gazeControlsSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-settings-accessinfo-headeye.png", 0.500, 0.500);
	return this;
}
interface ISettingsPopupLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ISettingsPopupLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ISettingsPopupLayoutSprite extends ISettingsPopupLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ISettingsPopupLayoutText extends ISettingsPopupLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ISettingsPopupLayoutPolygon extends Array<number> {
}
interface ISettingsPopupLayout {
	readonly audioSliderBg: ISettingsPopupLayoutArray<ISettingsPopupLayout_audioSliderBg0>;
	readonly switchControlsSprite: ISettingsPopupLayoutArray<ISettingsPopupLayout_switchControlsSpriteScan|ISettingsPopupLayout_switchControlsSpriteSelect>;
	readonly doneButton: ISettingsPopupLayout_doneButton;
	readonly soundAndCaptionSettingsButton: ISettingsPopupLayout_soundAndCaptionSettingsButton;
	readonly switchControlsButton: ISettingsPopupLayout_switchControlsButton;
	readonly gameplaySettingsButton: ISettingsPopupLayout_gameplaySettingsButton;
	readonly displaySettingsButton: ISettingsPopupLayout_displaySettingsButton;
	readonly helpButton: ISettingsPopupLayout_helpButton;
	readonly resetButton: ISettingsPopupLayout_resetButton;
	readonly audioPanel: ISettingsPopupLayout_audioPanel;
	readonly audioDescriptionsPanel: ISettingsPopupLayout_audioDescriptionsPanel;
	readonly closedCaptioningPanel: ISettingsPopupLayout_closedCaptioningPanel;
	readonly audioDescriptionsToggleBG: ISettingsPopupLayout_audioDescriptionsToggleBG;
	readonly closedCaptionsToggleBG: ISettingsPopupLayout_closedCaptionsToggleBG;
	readonly musicSliderIcon: ISettingsPopupLayout_musicSliderIcon;
	readonly soundEffectsSliderIcon: ISettingsPopupLayout_soundEffectsSliderIcon;
	readonly voiceoverSliderIcon: ISettingsPopupLayout_voiceoverSliderIcon;
	readonly flightSpeedPanel: ISettingsPopupLayout_flightSpeedPanel;
	readonly difficultyPanel: ISettingsPopupLayout_difficultyPanel;
	readonly difficultySliderBg: ISettingsPopupLayout_difficultySliderBg;
	readonly difficultySliderLabel: ISettingsPopupLayout_difficultySliderLabel;
	readonly flightSpeedSliderBg: ISettingsPopupLayout_flightSpeedSliderBg;
	readonly flightSpeedSliderLabel: ISettingsPopupLayout_flightSpeedSliderLabel;
	readonly textSizePanel: ISettingsPopupLayout_displayPanelBg;
	readonly colorBlindPanel: ISettingsPopupLayout_displayPanelBg;
	readonly reducedAnimationPanel: ISettingsPopupLayout_displayPanelBg;
	readonly buttonSizePanel: ISettingsPopupLayout_displayPanelBg;
	readonly contrastPanel: ISettingsPopupLayout_displayPanelBg;
	readonly backgroundImagesPanel: ISettingsPopupLayout_displayPanelBg;
	readonly textSizeSliderBg: ISettingsPopupLayout_textSizeSliderBg;
	readonly textSizeSliderLabel: ISettingsPopupLayout_textSizeSliderLabel;
	readonly buttonSizeSliderBg: ISettingsPopupLayout_textSizeSliderBg;
	readonly contrastSliderBg: ISettingsPopupLayout_textSizeSliderBg;
	readonly colorBlindSliderBg: ISettingsPopupLayout_textSizeSliderBg;
	readonly reducedAnimationSliderBg: ISettingsPopupLayout_textSizeSliderBg;
	readonly reducedAnimationSliderLabel: ISettingsPopupLayout_reducedAnimationSliderLabel;
	readonly backgroundImagesSliderLabel: ISettingsPopupLayout_backgroundImagesSliderLabel;
	readonly colorblindSliderLabel: ISettingsPopupLayout_colorblindSliderLabel;
	readonly contrastSliderLabel: ISettingsPopupLayout_contrastSliderLabel;
	readonly buttonSizeSliderLabel: ISettingsPopupLayout_buttonSizeSliderLabel;
	readonly controlsPanel: ISettingsPopupLayout_controlsPanel;
	readonly controlsPanelKeyboardTabBg: ISettingsPopupLayout_controlsPanelKeyboardTabBg;
	readonly controlsPanelSwitchTabBg: ISettingsPopupLayout_controlsPanelSwitchTabBg;
	readonly controlsPanelGazeTabBg: ISettingsPopupLayout_controlsPanelGazeTabBg;
	readonly controlsPanelKeyboardTabButton: ISettingsPopupLayout_controlsPanelKeyboardTabButton;
	readonly controlsPanelSwitchTabButton: ISettingsPopupLayout_controlsPanelSwitchTabButton;
	readonly controlsPanelGazeTabButton: ISettingsPopupLayout_controlsPanelGazeTabButton;
	readonly keyboardControlsSprite: ISettingsPopupLayout_keyboardControlsSprite;
	readonly gazeControlsSprite: ISettingsPopupLayout_gazeControlsSprite;
}
interface ISettingsPopupLayout_doneButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_soundAndCaptionSettingsButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_switchControlsButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_gameplaySettingsButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_displaySettingsButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_helpButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_resetButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_audioPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_audioDescriptionsPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_closedCaptioningPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_audioDescriptionsToggleBG extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_closedCaptionsToggleBG extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_audioSliderBg0 extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_musicSliderIcon extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_soundEffectsSliderIcon extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_voiceoverSliderIcon extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_flightSpeedPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_difficultyPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_difficultySliderBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_difficultySliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_flightSpeedSliderBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_flightSpeedSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_displayPanelBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_textSizeSliderBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_textSizeSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_reducedAnimationSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_backgroundImagesSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_colorblindSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_contrastSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_buttonSizeSliderLabel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanel extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelKeyboardTabBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelSwitchTabBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelGazeTabBg extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelKeyboardTabButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelSwitchTabButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_controlsPanelGazeTabButton extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_keyboardControlsSprite extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_switchControlsSpriteScan extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_switchControlsSpriteSelect extends ISettingsPopupLayoutSprite {
}
interface ISettingsPopupLayout_gazeControlsSprite extends ISettingsPopupLayoutSprite {
}
